import { RiCamera3Line } from "@itandi/itandi-bb-ui";
import type React from "react";
import { ScheduleInputModal } from "~/components/common/inspection_candidate_dates/ScheduleInputModal";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { Deal } from "~/models/Deal";
import type { InspectionCandidateDate } from "~/models/InspectionCandidateDate";
import { formatDate } from "~/utils/DateUtil";
import Styles from "../DealCard.module.scss";

type Props = {
	deal: Deal;
	handleMutate: () => Promise<void>;
	isVendor?: boolean;
};
/**
 * 訪問希望日更新用コンポーネント
 *
 * @for client, vendor
 */

export const DealInspectionCandidateDateCard: React.FC<Props> = ({
	deal,
	handleMutate,
	isVendor = false
}) => {
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const { dealInspectionCandidateDates: candidateDates } = deal;
	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>
				<RiCamera3Line className={Styles.TitleIcon} />
				<span>訪問希望日程</span>
				<div className={Styles.EditButtonWrapper}>
					{!isVendor && (
						<EditMenuButton onClick={handleOpen}>変更</EditMenuButton>
					)}
					{isOpen ? (
						<ScheduleInputModal
							deal={deal}
							handleClose={handleClose}
							handleMutate={handleMutate}
							isOpen={isOpen}
						/>
					) : null}
				</div>
			</h3>
			<div className={Styles.Content}>
				{candidateDates.length === 0 && (
					<dl className={Styles.ListContent}>
						<dt className={Styles.ListContentCaption}>希望日程</dt>
						<dd className={Styles.ListContentValue}>
							<span className={Styles.NotYet}>未定</span>
						</dd>
					</dl>
				)}
				{candidateDates.map((candidateDate: InspectionCandidateDate) => (
					<dl className={Styles.ListContent} key={candidateDate.id}>
						<dt className={Styles.ListContentCaption}>
							第{candidateDate.sort}希望
						</dt>
						<dd className={Styles.ListContentValue}>
							<span className={Styles.Date}>
								{formatDate(candidateDate.date)}
							</span>
							{candidateDate.time}
						</dd>
					</dl>
				))}
			</div>
		</div>
	);
};
